import Vue from 'vue';
import Configurator from './components/configurator/Configurator.vue';

$(function () {
    $('.layout .configurator-block').each(function () {
        new Vue({
            el: this,
            components: {Configurator}
        })
    });
});
